import { get, post } from "../utils/baseRequest";
import { yyrequest } from "@/utils/yyRequest";
const getBrowerInfo = () => {
  return {
    versions: (function () {
      const u = navigator.userAgent;
      return {
        trident: u.includes("Trident"), // IE内核
        presto: u.includes("Presto"), // opera内核
        webKit: u.includes("AppleWebKit"), // 苹果、谷歌内核
        gecko: u.includes("Gecko") && !u.includes("KHTML"), // 火狐内核
        mobile: !!u.match(/AppleWebKit.*Mobile.*/), // 是否为移动终端
        ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), // ios终端
        android: u.includes("Android") || u.includes("Adr"), // android终端
        iPhone: u.includes("iPhone"), // 是否为iPhone或者QQHD浏览器
        iPad: u.includes("iPad"), // 是否iPad
        webApp: !u.includes("Safari"), // 是否web应该程序，没有头部与底部
        weixin: u.includes("MicroMessenger"), // 是否微信 （2015-01-22新增）
        qq: u.match(/\sQQ/i) === " qq", // 是否QQ
        innerAmap: u.includes("YYApp"), // 是否是在约约app 中，需做兼容，以前使用 amap作为关键字
        dingTalk: u.includes("DingTalk"), // 是否在钉钉中
      };
    })(),
    language: (navigator.browserLanguage || navigator.language).toLowerCase(),
  };
};
const getQuery = () => {
  const result = {};
  const url = window.location.href;
  const reg1 = /([^?=&#]+)=([^?=&#]+)/g;
  const reg2 = /#([^?=&#]+)/g;
  url.replace(reg1, (n, x, y) => (result[x] = y));
  url.replace(reg2, (n, x) => (result["HASH"] = x));
  return result;
};
// 是否在端内
const isInnerYueyue = () => {
  const query = getQuery();
  if (query.isInnerApp && +query.isInnerApp === 1) {
    return true;
  }
  var info = getBrowerInfo();
  if (info.versions.innerAmap) {
    return true;
  }
  return false;
};
let isInnerApp = isInnerYueyue();
export function logEvent(data) {
  return post("/h5/v1/common/log/unicorn/event", data, {'Content-Type': 'application/json'})
    .then((res) => {
      // console.log('res', res);
    })
    .catch((err) => {
      console.log("埋点上报异常", err);
    });
}
// 获取图形验证码
function reqImageVerify(params) {
  return post("/h5/v1/unicorn/driver/user/common/getImageVerify", params);
}
// 获取短信验证码
function reqVerifyCode(params) {
  return post("/h5/v1/unicorn/driver/user/reserved/sendVerifyCode", params);
}
// 获取登陆
function reqLogin(params) {
  return post("/h5/v1/unicorn/driver/user/reserved/login", params);
}
// 司机协议签署- H5签署-新
function reqAgreementRecord(params) {
  return post("/h5/v1/unicorn/driver/user/agreement/sign", params);
}
// 获取开城省市
function reqOpenedProvinceCity(param, time) {
  if (isInnerApp) {
    return new Promise((resolve) => {
      const sign = ["channel", "diu", "_yy_eid"];
      console.log(param, "param");
      yyrequest(
        `/api/v1/unicorn/entry/recruit/queryOpenedProvinceCity`,
        param,
        time,
        sign,
        (res) => {
          resolve(res);
        }
      );
    });
  } else {
    return post("/h5/v1/unicorn/entry/recruit/queryOpenedProvinceCity", param);
  }
}
// 获取网申表单信息
function reqFormInfo(param, time) {
  if (isInnerApp) {
    return new Promise((resolve) => {
      const sign = ["channel", "diu", "_yy_eid"];
      yyrequest(
        `/api/v1/unicorn/entry/recruit/queryFormInfo`,
        param,
        time,
        sign,
        (res) => {
          resolve(res);
        }
      );
    });
  } else {
    return post("/h5/v1/unicorn/entry/recruit/queryFormInfo", param);
  }
}
// 提交网申
function reqCommitData(param, time) {
  if (isInnerApp) {
    return new Promise((resolve) => {
      const sign = ["channel", "diu", "_yy_eid"];
      yyrequest(
        `/api/v1/unicorn/entry/recruit/commitData`,
        param,
        time,
        sign,
        (res) => {
          resolve(res);
        }
      );
    });
  } else {
    return post("/h5/v1/unicorn/entry/recruit/commitData", param);
  }
}
// 获取网申状态
function queryAuditState(param, time) {
  if (isInnerApp) {
    return new Promise((resolve) => {
      const sign = ["channel", "diu", "_yy_eid"];
      yyrequest(
        `/api/v1/unicorn/entry/recruit/queryAuditState`,
        param,
        time,
        sign,
        (res) => {
          resolve(res);
        }
      );
    });
  } else {
    return post("/h5/v1/unicorn/entry/recruit/queryAuditState", param);
  }
}
// 获取云控数据
function reqModule(parmas) {
  return post("/h5/v1/common/config/module/update", parmas);
}
// 获取城市供应商
function reqSuppliers(param, time) {
  if (isInnerApp) {
    return new Promise((resolve) => {
      const sign = ["channel", "diu", "_yy_eid"];
      yyrequest(
        `/api/v1/unicorn/entry/recruit/querySuppliers`,
        param,
        time,
        sign,
        (res) => {
          resolve(res);
        }
      );
    });
  } else {
    return post("/h5/v1/unicorn/entry/recruit/querySuppliers", param);
  }
}
// 获取城市供应商
function reqActivityStatus(param, time) {
  if (isInnerApp) {
    return new Promise((resolve) => {
      const sign = ["channel", "diu", "_yy_eid"];
      yyrequest(
        `/api/v1/unicorn/marketing/invite/driver/checkStatus`,
        param,
        time,
        sign,
        (res) => {
          resolve(res);
        }
      );
    });
  } else {
    return post("/h5/v1/unicorn/marketing/invite/driver/checkStatus", param);
  }
}
// 获取可预约时间段
function reqExamTimeList(param, time) {
  if (isInnerApp) {
    return new Promise((resolve) => {
      const sign = ["channel", "diu", "_yy_eid"];
      yyrequest(
        `/api/v1/unicorn/entry/recruit/exam/examTime/pageList`,
        param,
        time,
        sign,
        (res) => {
          console.log(res, "0000");
          resolve(res);
        }
      );
    });
  } else {
    return post("/h5/v1/unicorn/entry/recruit/exam/examTime/pageList", param);
  }
}

// 获取租户名称和运力车队
function reqUserInfo(param, time) {
  if (isInnerApp) {
    return new Promise((resolve) => {
      const sign = ["channel", "diu", "_yy_eid"];
      yyrequest(
        `/api/v1/unicorn/entry/recruit/exam/userInfo`,
        param,
        time,
        sign,
        (res) => {
          resolve(res);
        }
      );
    });
  } else {
    return post("/h5/v1/unicorn/entry/recruit/exam/userInfo", param);
  }
}

// 获取考点信息
function reqExamAddress(param, time) {
  if (isInnerApp) {
    return new Promise((resolve) => {
      const sign = ["channel", "diu", "_yy_eid"];
      yyrequest(
        `/api/v1/unicorn/entry/recruit/exam/examAddress/getExamAddress`,
        param,
        time,
        sign,
        (res) => {
          resolve(res);
        }
      );
    });
  } else {
    return post(
      "/h5/v1/unicorn/entry/recruit/exam/examAddress/getExamAddress",
      param
    );
  }
}

// 预约路考
function reqAppointExamAddress(param, time) {
  if (isInnerApp) {
    return new Promise((resolve) => {
      const sign = ["channel", "diu", "_yy_eid"];
      yyrequest(
        `/api/v1/unicorn/entry/recruit/exam/examAddress/appointment`,
        param,
        time,
        sign,
        (res) => {
          resolve(res);
        }
      );
    });
  } else {
    return post(
      "/h5/v1/unicorn/entry/recruit/exam/examAddress/appointment",
      param
    );
  }
}

//聚合招募新增 获取sp列表
function reqCpList(params) {
  return post("/capi/v1/unicorn/entry/recruit/homePage", params);
}
// 获取开通城市列表
function reqOpenCity(params) {
  return post("/capi/v1/unicorn/entry/recruit/cityList", params);
}
// 获取对应租户icon和名称
function getAppConfig(params) {
  return post("/h5/v1/unicorn/entry/recruit/getAppConfig", params);
}
// 0120 迭代新增
// OCR获取身份证信息
function reqOcrCardInfo(param, time) {
  if (isInnerApp) {
    return new Promise((resolve) => {
      const sign = ["channel", "diu", "_yy_eid"];
      yyrequest(
        `/api/v1/unicorn/entry/recruit/idCardOcr`,
        param,
        time,
        sign,
        (res) => {
          resolve(res);
        }
      );
    });
  } else {
    return post("/h5/v1/unicorn/entry/recruit/idCardOcr", param);
  }
}
// OCR获取驾驶证信息
function reqOcrDriverInfo(param, time) {
  if (isInnerApp) {
    return new Promise((resolve) => {
      const sign = ["channel", "diu", "_yy_eid"];
      yyrequest(
        `/api/v1/unicorn/entry/recruit/driverLicenceOcr`,
        param,
        time,
        sign,
        (res) => {
          resolve(res);
        }
      );
    });
  } else {
    return post("/h5/v1/unicorn/entry/recruit/driverLicenceOcr", param);
  }
}
// 获取年龄和驾龄校验规则
function reqAgeRule(param, time) {
  if (isInnerApp) {
    return new Promise((resolve) => {
      const sign = ["channel", "diu", "_yy_eid"];
      yyrequest(
        `/api/v1/unicorn/entry/rule/query`,
        param,
        time,
        sign,
        (res) => {
          resolve(res);
        }
      );
    });
  } else {
    return post("/h5/v1/unicorn/entry/rule/query", param);
  }
}
// 查询司机是否显示绿色通道
function reqGreenChannel(param, time) {
  if (isInnerApp) {
    return new Promise((resolve) => {
      const sign = ["channel", "diu", "_yy_eid"];
      yyrequest(
        `/api/v1/unicorn/entry/recruit/greenChannel/display`,
        param,
        time,
        sign,
        (res) => {
          resolve(res);
        }
      );
    });
  } else {
    return post("/h5/v1/unicorn/entry/recruit/greenChannel/display", param);
  }
}
// 获取电子驾照信息ocr
function reqOcrElectronicInfo(param, time) {
  if (isInnerApp) {
    return new Promise((resolve) => {
      const sign = ["channel", "diu", "_yy_eid"];
      yyrequest(
        `/api/v1/unicorn/entry/recruit/electronicLicenseOcr`,
        param,
        time,
        sign,
        (res) => {
          resolve(res);
        }
      );
    });
  } else {
    return post("/h5/v1/unicorn/entry/recruit/electronicLicenseOcr", param);
  }
}
// 获取电子驾照入口是否展示
function reqElectronicLicenseShow(param, time) {
  if (isInnerApp) {
    return new Promise((resolve) => {
      const sign = ["channel", "diu", "_yy_eid"];
      yyrequest(
        `/api/v1/unicorn/entry/recruit/electronicLicenseGray`,
        param,
        time,
        sign,
        (res) => {
          resolve(res);
        }
      );
    });
  } else {
    return post("/h5/v1/unicorn/entry/recruit/electronicLicenseGray", param);
  }
}
// 地推招募新增
function reqCheckInviteAddress(param, time) {
  if (isInnerApp) {
    return new Promise((resolve) => {
      const sign = ["channel", "diu", "_yy_eid"];
      yyrequest(
        `/api/v1/unicorn/marketing/geopush/task/recruit/checkInviteAddress`,
        param,
        time,
        sign,
        (res) => {
          resolve(res);
        }
      );
    });
  } else {
    return post(
      "/h5/v1/unicorn/marketing/geopush/task/recruit/checkInviteAddress",
      param
    );
  }
}
// 获取transId 0724
function reqTransId(param, time) {
  if (isInnerApp) {
    return new Promise((resolve) => {
      const sign = ["channel", "diu", "_yy_eid"];
      yyrequest(
        `/api/v1/unicorn/entry/common/getTransId`,
        param,
        time,
        sign,
        (res) => {
          resolve(res);
        }
      );
    });
  } else {
    return post("/h5/v1/unicorn/entry/common/getTransId", param);
  }
}

/**
 * @apiName 代驾云控
 */
function getCloudData(param) {
  return post("/h5/v1/common/config/module/update", param);
}

export {
  reqImageVerify,
  reqVerifyCode,
  reqLogin,
  reqOpenedProvinceCity,
  reqFormInfo,
  reqCommitData,
  reqModule,
  queryAuditState,
  reqSuppliers,
  reqActivityStatus,
  reqExamTimeList,
  reqExamAddress,
  reqAppointExamAddress,
  reqUserInfo,
  reqCpList,
  reqOpenCity,
  getAppConfig,
  reqOcrCardInfo,
  reqOcrDriverInfo,
  reqAgeRule,
  reqGreenChannel,
  reqCheckInviteAddress,
  reqOcrElectronicInfo,
  reqElectronicLicenseShow,
  reqTransId,
  getCloudData,
  reqAgreementRecord
};
